import FolderIcon from '@mui/icons-material/Folder';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import type React from 'react';
import type { ListDirToolArguments } from 'services/types/ticket';

import MessageWrapper from './MessageWrapper';

interface Props {
  args: string;
}

const ListDirToolComponent: React.FC<Props> = ({ args }) => {
  let parsedArgs: ListDirToolArguments;

  try {
    parsedArgs = JSON.parse(args) as ListDirToolArguments;
  } catch (_error) {
    return (
      <MessageWrapper caption="Herramienta de Directorio" align="left">
        <Typography color="error">Error al parsear argumentos: {args}</Typography>
      </MessageWrapper>
    );
  }

  return (
    <MessageWrapper caption="Listar directorio" align="left">
      <Box>
        <Box
          sx={{
            mb: 2,
          }}
        >
          <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 1 }}>
            <FolderIcon sx={{ fontSize: 16, mr: 1, verticalAlign: 'text-bottom' }} />
            Explorando directorio:
          </Typography>
          <Paper
            variant="outlined"
            sx={{
              fontFamily: 'monospace',
              p: 1.5,
            }}
          >
            {parsedArgs.directoryPath}
          </Paper>
        </Box>
      </Box>
    </MessageWrapper>
  );
};

export default ListDirToolComponent;
